import React from "react";
import { Link, withRouter } from "react-router-dom";
import Table from "react-bootstrap/Table";
import { API_ROOT1 } from "./utils/api-config";

class CustomerStats extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.props;
  }

  render() {
    const { customers } = this.props;

    return (
      <div>
        <style type="text/css">
          {`
    .btn-flat {
      display: inline;
      background-color: #cdcecf;
      color: white;
      margin-bottom: 10px;
      width: 100%;
    }
    .bg-flat {
      background-color: #7dc3ae85;
      color: #2f0246;
      border-radius: 8px;
      border: 1px solid teal;  
    }
    `}
        </style>
        <Table className="bg-flat" responsive>
          <thead>
            <tr>
              <th>Customer ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Deliveries</th>
            </tr>
          </thead>
          <tbody>
            {customers.map((user, i) => (
              <tr key={customers[i].id}>
                <td>
                  <Link to={`/customers/${customers[i].id}`}>
                    {customers[i].id}
                  </Link>
                </td>
                <td>
                  {customers[i].first_name} {customers[i].last_name}
                </td>
                <td>{customers[i].email}</td>
                <td>{customers[i].phone}</td>
                <td>
                  <a
                    href={`${API_ROOT1}/customerdeliveries?id=${customers[i].id}`}
                  >
                    {customers[i].delivery_ids.length}
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default withRouter(CustomerStats);
